export default __webpack_public_path__ + "static/media/rarity-4.5d2d61df.png";